import React from 'react';
import { Lock, Heart } from 'lucide-react';
import { OfferSection } from './OfferSection';
export function FinalOfferSection() {
  return <section className="py-16 px-4 bg-[#FDF0F3] border-t border-[#E2E8F0] relative overflow-hidden" data-id="element-84">
      {/* Glow effect */}
      <div className="absolute bottom-0 left-0 w-full h-[300px] bg-[#B83A52] opacity-[0.05] blur-[80px] pointer-events-none" data-id="element-85"></div>

      <div className="max-w-[600px] mx-auto relative z-10" data-id="element-86">
        <div className="space-y-8 mb-12 text-left text-[#4A4A6A]" data-id="element-87">
          {/* Closing thought */}
          <div className="bg-white p-8 rounded-xl border border-[#E2E8F0] shadow-sm text-center" data-id="element-88">
            <Heart className="w-8 h-8 text-[#B83A52] mx-auto mb-4 fill-[#B83A52]/10" data-id="element-89" />
            <h4 className="text-[#1C1C2E] font-serif font-bold text-xl mb-4" data-id="element-90">
              "El cáncer no lo enfrenta una persona sola. Lo enfrenta una
              familia."
            </h4>
            <p className="text-[#4A4A6A] mb-3 text-sm" data-id="element-91">
              Pero solo si sabe cómo.
            </p>
            <p className="font-bold text-[#1B3A6B] text-lg" data-id="element-92">
              Tú ya decidiste no dejarlo solo. Ahora aprende cómo acompañarlo.
            </p>
          </div>
        </div>

        <OfferSection showUrgency={false} showCountdown={false} showGuarantee={false} showPayment={false} ctaText="SÍ — QUIERO APRENDER A ESTAR AHÍ DE VERDAD →" data-id="element-93" />

        <div className="text-center mt-6 space-y-2" data-id="element-94">
          <p className="text-xs text-[#4A4A6A] flex items-center justify-center gap-1.5" data-id="element-95">
            <Lock className="w-3 h-3 text-[#1B3A6B]" data-id="element-96" /> Tu compra está 100%
            protegida
          </p>
        </div>
      </div>
    </section>;
}